import { tv } from 'tailwind-variants';

const subOptionButton = tv({
  base: 'w-full justify-start rounded-none font-medium h-8 text-gray-700 hover:opacity-100 hover:bg-zinc-100',
  variants: {
    interventionStatus: {
      in_progress: 'text-[#265FCF]',
      jaimy: 'text-[#af1b3c]',
      new: 'text-[#F2BB05]',
      success: 'text-[#77E062]',
      trashed: 'text-[#9e9e9e]',
    },
  },
});

export const dropdownStyles = {
  subOptionButton,
};
